package com.exura.features.plandefinition.domain.builder.series

import com.exura.features.plandefinition.domain.builder.BuilderField
import com.exura.features.plandefinition.domain.model.element.BasePlanElement
import com.exura.features.plandefinition.domain.model.series.BaseAnchoredSeries
import com.exura.features.plandefinition.domain.model.series.SeriesSpawnType

abstract class BaseAnchoredSeriesBuilder<E: BasePlanElement, T : BaseAnchoredSeries<out E>>(
    seriesType: SeriesSpawnType,
) : BaseSeriesBuilder<E, T>(seriesType) {

    private val relativeDay = BuilderField<Int>(isRequired = true, default = 0)

    fun relativeDay(): Int? = relativeDay.getValue()

    fun setRelativeDay(newValue: Int) = apply {
        val res = relativeDay.setValue(newValue)
        updateChangedState(res)
        updateBuildState(res)
        updateElementsCalculationState(res)
    }

    override fun markSaved(): BaseSeriesBuilder<E, T> {
        relativeDay.markSaved()
        return super.markSaved()
    }

    override fun validate(): List<String> {
        val fields = mapOf(
            "relativeDay" to relativeDay,
        )
        val messages = validateFields(fields)
        return messages + super.validate()
    }

}
